/* global getURLParams readCookie */


const searchParamsThatDoNotMinimizeCallout = {
    sortBy: true,
    centerLat: true,
    centerLng: true,
    state: true,
    cityName: true,
    countyName: true,
    locationName: true,
    includeNearbyLocations: true,
};

const getMapFeatureUrl = function (searchUrl) {
    return BASIC_MAP_URL + getSearchCenterParams(searchUrl);
};
export const BASIC_MAP_URL = baseURL + 'donors/map.html';

const getSearchCenterParams = function (searchUrl) {
    if (!searchUrl) {
        return '';
    }

    const searchParams = getURLParams(searchUrl);
    // The reason for only passing some of these parameters is because the map has to be centered on one geospatial location.
    // The map will also handle combinations of these parameters in a similar priority order, but
    // I think it's better to be explicit what to render as the center.
    if (searchParams.centerZip) {
        return `?startingZip=${searchParams.centerZip}`;
    }

    if (searchParams.cityName && searchParams.state) {
        return `?cityName=${searchParams.cityName}&state=${searchParams.state}`;
    }

    if (searchParams.state) {
        return `?state=${searchParams.state}`;
    }

    if (searchParams.centerLat && searchParams.centerLng) {
        return `?centerLat=${searchParams.centerLat}&centerLng=${searchParams.centerLng}`;
    }


    return '';
};

export const mapFeatureCalloutUtils = {
    getMapFeatureUrl: getMapFeatureUrl,
};
